<div class="flex flex-wrap items-center gap-1" role="list" aria-label="Accepted payment methods">
  <span
    *ngFor="let method of methods"
    role="listitem"
    class="flex shrink-0"
    [attr.aria-label]="method.label"
    [title]="method.label"
    [innerHTML]="method.svg | safe: 'html'"
  ></span>
</div>
